import Papaparse from 'papaparse';
import JSZip from 'jszip';

export async function readFile(fileBlob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = err => reject(err);
    reader.onload = evt => resolve(evt.target.result);
    reader.readAsText(fileBlob);
  });
}

export async function parseCSV(fileContents, { beforeFirstChunk } = {}) {
  return new Promise((resolve, reject) => {
    Papaparse.parse(fileContents, {
      header: true,
      beforeFirstChunk: typeof beforeFirstChunk === 'function' ? beforeFirstChunk : undefined,
      complete: resolve,
      error: reject,
    });
  });
}

export function parseZIP(fileRead, opts = {}) {
  return JSZip.loadAsync(fileRead, opts);
}



// WEBPACK FOOTER //
// ./src/lib/files.js